import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Subscription = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M6.9,42c-0.494,0 -0.9,-0.406 -0.9,-0.9c0,-0.494 0.406,-0.9 0.9,-0.9l34.2,0c0.494,0 0.9,0.406 0.9,0.9c0,0.494 -0.406,0.9 -0.9,0.9l-34.2,0Zm2.1,-4.166c-0.797,0.011 -1.564,-0.308 -2.119,-0.88c-0.572,-0.555 -0.891,-1.323 -0.881,-2.12l0,-21.334c-0.011,-0.797 0.308,-1.565 0.88,-2.12c0.555,-0.573 1.323,-0.891 2.12,-0.88l30,0c1.644,0.002 2.997,1.355 3,3l0,21.334c-0.003,1.645 -1.356,2.997 -3,3l-30,0Zm-0.6,-3c0.003,0.328 0.272,0.597 0.6,0.6l30,0c0.159,0 0.312,-0.065 0.423,-0.18c0.116,-0.11 0.181,-0.263 0.18,-0.423l0,-9.931l-31.203,0l0,9.934Zm0.18,-21.757c-0.116,0.11 -0.181,0.263 -0.18,0.423l0,4.2l31.2,0l0,-4.2c-0.003,-0.329 -0.272,-0.598 -0.6,-0.601l-30,0c-0.159,0 -0.312,0.064 -0.423,0.178l0.003,0Zm9.423,19.956l0,-2.398l7.2,0l0,2.399l-7.2,-0.001Zm-7.2,0l0,-2.398l4.798,0l0,2.399l-4.798,-0.001Zm-3.903,-25.233c-0.494,0 -0.9,-0.406 -0.9,-0.9c0,-0.494 0.406,-0.9 0.9,-0.9l34.2,0c0.494,0 0.9,0.406 0.9,0.9c0,0.494 -0.406,0.9 -0.9,0.9l-34.2,0Z" fill={fill} stroke={"#000"} strokeOpacity={0} strokeWidth={"0.9px"} />
    </svg>
  );
};

Subscription.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Subscription.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
